import { useTranslation } from "react-i18next";
import { Button } from "~/components/ui/button";
import { Picture } from "~/components/ui/picture";
import { SectionTitle } from "~/components/ui/section-title";
import { useAddToEmbeddedCart } from "~/lib/use-embedded-cart";
import type { ProductLastChanceContent } from "~/data/products/types";

interface LastChanceSectionProps {
  productCode: string;
  content: ProductLastChanceContent;
}

export function LastChanceSection({ productCode, content }: LastChanceSectionProps) {
  const { t } = useTranslation("products");
  const addToCart = useAddToEmbeddedCart(productCode);

  return (
    <section className="bg-bouncie-900 overflow-hidden">
      <div className="wrap relative flex flex-col items-center gap-6 py-12 lg:min-h-[367px] lg:flex-row lg:py-0">
        {content.image && (
          // Wrapper keeps <picture>'s <source> children out of the flex gap. Images carry their
          // own shadow and transparent margin; from lg the desktop one sits on the right.
          <div className="w-[367px] shrink-0 lg:absolute lg:top-[38px] lg:right-0 lg:w-[528px] xl:right-[78px]">
            <Picture
              className="h-auto w-full"
              src={content.image}
              mobileSrc={content.mobileImage}
              alt={t(content.imageAlt ?? "")}
            />
          </div>
        )}
        <div className="relative z-1 flex flex-col items-center gap-6 lg:items-start xl:pl-[102px]">
          <SectionTitle className="max-w-[301px] text-center text-white lg:max-w-[483px] lg:text-left">
            {t(content.headline)}
          </SectionTitle>
          <Button
            data-sid="pdp-last-chance-add-to-cart"
            variant="primary"
            className="h-11 text-base leading-5 tracking-[0.16px] lg:h-[52px] lg:w-[260px]"
            onClick={addToCart}
          >
            {t(content.ctaLabel)}
          </Button>
        </div>
      </div>
    </section>
  );
}
